<template>
  <div ref="page" class="diagnosis-en">
    <legend-diagnosis v-if="isDiagnosis"></legend-diagnosis>
    <legend-immokey v-else></legend-immokey>
    <base-form
      ref="form"
      class="search-bar"
      v-model="toolbar.data"
      :form-items="toolbar.formItems"
      label-width="auto"
      input-trim
      inline
    ></base-form>
    <base-table-lite
      ref="table"
      :url="action"
      :columns="columns"
      :init-search="false"
      @loaded="tableLoaded"
    ></base-table-lite>
    <diag-extra-view
      ref="diagExtraView"
      class="diag-extra-view"
      v-model="extraView.visible"
      :packid="extraView.packid"
      :version="extraView.version"
      :lang="currentLang"
      :sub_field="extraView.sub_field"
      :nos="extraView.nos"
      :label="extraView.label"
      :searchText="extraView.searchText"
    ></diag-extra-view>
  </div>
</template>

<script>
export default {
  name: 'diagnosis-en',
  data() {
    var currentLang = this.$root.getCurrentLang()
    var currentRegion = this.$root.getCurrentRegion()
    return {
      firstLoad: true,
      profile: '',
      subcategory: '',
      //默认主功能表查询字段
      defaultSearchField: [
        'year',
        'series',
        'displacement',
        'engine_type',
        'chassis',
        'part',
        'area',
        'model',
        'system',
        'system_type'
      ],
      defaultSearchFieldImmokey: [
        'year',
        'series',
        'key_type',
        'immo_type',
        'chassis',
        'area',
        'model',
        'system',
        'system_type'
      ],
      searchFieldFormItems: [],
      //默认额外功能表查询字段
      defaultExtraSearchField: ['actuation_test', 'special_functions'],
      extraSearchFields: [],
      currentFields: [],
      currentLang,
      currentLangLowerCase: currentLang.toLowerCase(),
      currentProduct: null,
      //currentBrand: '',
      extraView: {
        visible: false,
        packid: '',
        version: '',
        lang: currentLang,
        sub_field: '',
        nos: '',
        label: ''
      },
      toolbar: {
        formItems: [
          {
            label: 'Subcategory', // 功能类型
            prop: 'subcategory',
            component: 'form-select',
            value: this.getPackCategory(),
            bind: {
              options: [
                {
                  label: 'DIAGNOSTICS', // 诊断
                  value: 'DIAGNOSTICS'
                },
                {
                  label: 'IMMOBILIZER', //防盗匹配
                  value: 'IMMOBILIZER'
                }
              ]
            },
            on: {
              change: (newVal) => {
                this.subcategory = newVal
                this.firstLoad = false
                this.toolbar.formItems[2].bind.packid = ''
                this.toolbar.formItems[2].bind.version = ''
                this.toolbar.formItems[2].bind.category = this.getCategory()
                this.$nextTick(() => {
                  for (let item of this.form.items) {
                    if (item.getBrand && typeof item.getBrand == 'function') {
                      // console.log(item)
                      item.getBrand()
                      break
                    }
                  }
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '产品' : 'Product',
            prop: 'product',
            component: 'product-select',
            bind: {
              lang: currentLang,
              region: currentRegion,
              category: 'diag',
              profile: this.getProfile()
            },
            on: {
              productChange: (product) => this.productChange(product)
            }
          },
          {
            label: currentLang == 'CN' ? '品牌' : 'Brand',
            prop: 'pack_brand',
            component: 'brand-select',
            bind: {
              lang: currentLang,
              category: this.getCategory(),
              profile: '',
              packid: '',
              version: ''
            },
            on: {
              outVersion: (option, versions) => {
                const { profile, brand, packid, version } = option
                const category = this.getCategory()
                const queryObj = { category, profile, brand, packid, version }
                this.toolbar.query.packid = option.packid
                this.toolbar.query.brand = JSON.stringify({
                  Field: 'brand',
                  ComparePattern: 'EQ',
                  Values: [option.brand]
                })
                this.$nextTick(() => {
                  const formItemVersion = this.toolbar.formItems[3]
                  formItemVersion.bind.queryObj = queryObj
                  formItemVersion.bind.version = versions
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '版本' : 'Version',
            prop: 'version',
            component: 'version-select-en',
            bind: { version: [], queryObj: {} },
            on: {
              change: (newVal) => this.loadData(newVal)
            }
          }
        ],
        data: {},
        query: {
          packid: null,
          brand: ''
        }
      },
      columns: []
    }
  },
  created() {
    this.$root.autoSetCurrentLang()
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    },
    isDiagnosis() {
      return this.getPackCategory() != 'IMMOBILIZER'
    },
    action() {
      return this.isDiagnosis ? 'view/getDiagData' : 'view/getDiagImmokeyData'
    },
    diagExtraView() {
      return this.$refs.diagExtraView
    }
  },
  methods: {
    productChange(product){
      this.currentProduct = product
      this.profile=product.profile
      this.toolbar.query.profile=product.profile
      this.$nextTick(() => {
        const formItemFunc = this.toolbar.formItems[2]
        formItemFunc.bind.profile = product.profile
        formItemFunc.bind.category = this.getCategory()
        formItemFunc.bind.packid = ''
        formItemFunc.bind.version = ''
        this.toolbar.formItems[2].value = ''
        // 如果是"产品详情页"跳转至"功能表查询"，首次加载时从route中获取packid,version参数，用于设置默认查询条件
        if (this.getProfile() == product.profile) {
          formItemFunc.bind.packid = this.getPackId()
          formItemFunc.bind.version = this.getPackVersion()
        }
        this.firstLoad = false
      })
    },
    loadData(version) {
      this.$nextTick(() => {
        this.isDiagnosis
          ? this.getDiagField(version)
          : this.getImmokeyField(version)
      })
    },
    getProfile() {
      return this.firstLoad || this.firstLoad === undefined
        ? this.$route.query.configName
        : ''
    },
    getPackId() {
      return this.firstLoad ? this.$route.query.packId : ''
    },
    getPackVersion() {
      return this.firstLoad ? this.$route.query.packVer : ''
    },
    getPackCategory() {
      return this.subcategory || this.$route.query.packCategory || 'DIAGNOSTICS'
    },
    getCategory() {
      const packCategory = this.getPackCategory()
      return packCategory == 'IMMOBILIZER' ? 'immokey' : 'diag'
    },
    assertField(field) {
      //这些列不显示
      if (['brand', 'version'].indexOf(field) > -1) {
        return false
      }
      if (this.currentProduct) {
        switch (field) {
          case 'programming':
            return this.currentProduct.programming
          case 'coding':
            return this.currentProduct.coding
          case 'special_functions':
            return this.currentProduct.special_functions
          case 'actuation_test':
            return this.currentProduct.actuation_test
          case 'component_protection':
          case 'parameterized':
            return this.currentProduct.online_functions
          case 'boot_functions':
            return this.currentProduct.boot_functions
          case 'ecu_configuration':
            return this.currentProduct.ecu_configuration
        }
      }
      return true
    },
    getDiagField(currentVersion) {
      if (!currentVersion) {
        this.resetTableData()
        return
      }
      var searchData = this.toolbar.data
      this.$post('view/getDiagField', {
        packid: this.toolbar.query.packid,
        version: searchData.version,
        lang: this.currentLang,
        profile: this.profile
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            this.searchFieldFormItems = []
            this.extraSearchFields = []
            var currentFields = []
            this.initToolbarFormItems()
            var fieldIndex = 0
            if (resp.data.data.length == 0) {
              this.resetTableData()
              return
            }
            for (var item of resp.data.data) {
              //过滤不显示的列
              if (!this.assertField(item.field)) {
                continue
              }
              var column = {
                bind: {
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field
                }
              }
              //用对应组件渲染显示数据类型
              if (item.data_type) {
                column.default = {
                  component: item.data_type.replace('|', ''),
                  bind: { lang: this.currentLang },
                  on: { view: this.viewExtra }
                }
              }
              columns.push(column)

              //查找动态查询条件框
              if (this.defaultSearchField.indexOf(item.field) > -1) {
                currentFields.push(item.field)
                this.searchFieldFormItems.push({
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                  component: 'field-select',
                  bind: {
                    fieldIndex: fieldIndex,
                    category: 'diag',
                    field: item.field,
                    lang: this.currentLang,
                    packid: this.toolbar.query.packid,
                    version: searchData.version
                    //brand: this.currentBrand,
                  },
                  on: {
                    valchange: (index, val) => {
                      this.resetSearchFieldBeginBy(index, val)
                      this.tableSearch()
                    }
                  }
                })
                fieldIndex++
              }

              //查找额外功能表动态查询条件框
              if (this.defaultExtraSearchField.indexOf(item.field) > -1) {
                this.extraSearchFields.push({
                  field: item.field,
                  label: item[this.currentLang.toLowerCase()]
                })
              }
            }
            this.currentFields = currentFields
            this.columns = columns
            this.$nextTick(() => {
              for (var item of this.searchFieldFormItems) {
                this.toolbar.formItems.push(item)
              }
              if (this.extraSearchFields.length > 0) {
                this.toolbar.formItems.push({
                  label:
                    this.currentLang.toLowerCase() == 'cn'
                      ? '功能'
                      : 'Function',
                  prop: 'extra',
                  component: 'extra-search',
                  bind: {
                    style: {
                      width: '215px'
                    },
                    lang: this.currentLang,
                    placeholder: this.extraSearchFields
                      .map((item) => item.label)
                      .join(' / ')
                  },
                  on: {
                    search: (val) => {
                      if (this.checkExtraCondition()) {
                        this.tableSearch()
                      }
                    }
                  }
                })
              }
              //第一个动态查询条件框价值初始化option
              this.firstSearchFieldInit()
              this.tableSearch()
            })
          } else {
            this.$message(resp.data.msg || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
        })
    },
    getImmokeyField(currentVersion) {
      if (!currentVersion) {
        this.resetTableData()
        return
      }
      var searchData = this.toolbar.data
      this.$post('view/getImmokeyField', {
        packid: this.toolbar.query.packid,
        version: searchData.version,
        lang: this.currentLang
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            this.searchFieldFormItems = []
            this.initToolbarFormItems()
            var fieldIndex = 0
            if (resp.data.data.length == 0) {
              this.resetTableData()
              return
            }
            for (var item of resp.data.data) {
              //过滤不显示的列
              if (['brand', 'version'].indexOf(item.field) > -1) {
                continue
              }
              var column = {
                bind: {
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field
                }
              }
              //用对应组件渲染显示数据类型
              if (item.data_type) {
                column.default = {
                  component: item.data_type.replace('|', ''),
                  bind: { lang: this.currentLang }
                }
              }
              columns.push(column)

              if (this.defaultSearchFieldImmokey.indexOf(item.field) > -1) {
                this.searchFieldFormItems.push({
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                  component: 'field-select',
                  bind: {
                    fieldIndex: fieldIndex,
                    category: 'immokey',
                    field: item.field,
                    lang: this.currentLang,
                    packid: this.toolbar.query.packid,
                    version: searchData.version
                    // brand: this.currentBrand
                  },
                  on: {
                    valchange: (index, val) => {
                      this.resetSearchFieldBeginBy(index, val)
                      this.tableSearch()
                    }
                  }
                })
                fieldIndex++
              }
            }
            this.columns = columns
            this.$nextTick(() => {
              for (var item of this.searchFieldFormItems) {
                this.toolbar.formItems.push(item)
              }
              //第一个动态查询条件框价值初始化option
              this.firstSearchFieldInit()
              this.tableSearch()
            })
          } else {
            this.$message(resp.data.msg || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
        })
    },
    resetTableData() {
      for (let item of this.form.items) {
        if (item.name == 'field-select') {
          item.reset()
        }
      }
      this.table.setTableData({
        rows: [],
        total: 0
      })
    },
    checkExtraCondition() {
      for (var item of this.searchFieldFormItems) {
        if (
          item.prop.indexOf('system') < 0 &&
          item.prop.indexOf('part') < 0 &&
          item.$this.options.length > 0
        ) {
          if (!item.$this.val) {
            alert(
              (this.currentLang.toLowerCase() == 'cn'
                ? '请选择 '
                : 'Please select ') + item.label
            )
            return false
          }
        }
      }
      return true
    },
    initToolbarFormItems() {
      if (this.toolbar.formItems.length > 4) {
        //找出多余的prop
        var props = []
        for (var i = 4; i < this.toolbar.formItems.length; i++) {
          props.push(this.toolbar.formItems[i].prop)
        }
        this.toolbar.formItems.splice(4)
        //删除多余的prop
        for (var prop of props) {
          this.$delete(this.toolbar.data, prop)
        }
      }
    },
    getSearchData() {
      var searchData = Object.assign({}, this.toolbar.data, this.toolbar.query)
      if (this.isDiagnosis) {
        for (let field of this.defaultSearchField) {
          if (searchData[field]) {
            searchData[field] = JSON.stringify({
              Field: field,
              ComparePattern: 'EQ',
              Values: [searchData[field]]
            })
          }
        }
        if (this.extraSearchFields.length > 0) {
          searchData.extraFields = this.extraSearchFields
            .map((item) => item.field)
            .join(',')
        }
        return searchData
      } else {
        for (let field of this.defaultSearchFieldImmokey) {
          if (searchData[field]) {
            searchData[field] = JSON.stringify({
              Field: field,
              ComparePattern: 'EQ',
              Values: [searchData[field]]
            })
          }
        }
        return searchData
      }
    },
    tableSearch() {
      this.table.table.doLayout()
      this.$nextTick(() => {
        this.table.searchData = this.getSearchData()
        this.table.searchData.lang = this.currentLang
        this.table.query.PageIndex = 1
        this.table.refreshData()
      })
    },
    viewExtra(scope) {
      var searchData = this.table.searchData
      if (this.defaultExtraSearchField.indexOf(scope.column.property) > -1) {
        this.extraView.searchText = searchData.extra
      } else {
        this.extraView.searchText = ''
      }
      this.extraView.packid = this.toolbar.query.packid
      this.extraView.version = searchData.version
      this.extraView.lang = searchData.lang
      // console.log(scope.column)
      this.extraView.sub_field = scope.column.property
      this.extraView.label = scope.column.label
      this.extraView.visible = true

      this.extraView.nos = this.$getPropValue(scope.row, scope.column.property)
    },
    tableLoaded() {
      window.parent.postMessage(
        {
          callback: 'setIframeHeight',
          args: [this.$refs.page.scrollHeight + 50]
        },
        '*'
      )
    },
    firstSearchFieldInit() {
      this.$nextTick(() => {
        var searchData = this.getSearchData()
        for (var item of this.$refs.form.items) {
          if (item.fieldIndex == 0) {
            item.getFieldOptions(searchData)
            break
          }
        }
      })
    },
    resetSearchFieldBeginBy(index, val) {
      let searchData = this.getSearchData()
      for (let item of this.$refs.form.items) {
        if (item.fieldIndex > index) {
          item.reset()
          if (val && item.fieldIndex == index + 1) {
            const subcategory = this.subcategory
            item.getFieldOptions({ ...searchData, subcategory })
          }
        }
      }
      if (this.isDiagnosis) {
        //重置extra-search (extra-search为最后一个)
        this.$refs.form.items[this.$refs.form.items.length - 1].reset()
      }
    }
  }
}
</script>
<style lang="less">
.diagnosis-en {
  .diag-extra-view {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
}
</style>
